import VideoIcon from "@infinitaslearning/pixel-icons/Video";
import { Button } from "components/Button";
import { Icon } from "components/Icon";
import styled from "styled-components/macro";
import { Heading5 } from "styles/elements/Headings";
import type { ElearningTheme } from "themes/elearning.theme";

interface Props {
  theme: ElearningTheme;
}

export const StyleContainer = styled.div<Props>`
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
  padding-bottom: 10px;
  max-width: 100%;
  align-items: flex-start;
  justify-content: flex-start;
`;

export const ButtonsContainer = styled.div<Props>`
  width: 100%;
  display: flex;
  flex-direction: row;
  margin-bottom: 40px;
`;

export const DownloadAllButton = styled(Button)<Props>`
  margin-right: 10px;
  margin-top: 16px;
  width: 23%;
  align-self: flex-start;
`;

export const AssetsContainer = styled.div<Props>`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
`;

export const StyledIcon = styled(Icon)<Props>`
  font-size: 35px;
  color: ${(props: Props) => props.theme.palette.neutral._20};
`;

export const CardTitle = styled(Heading5)<Props>`
  margin-top: 8px;
  width: 96px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;

`;

export const StyledCard = styled.a<Props>`
  position: relative;
  text-decoration: none;
  width: 96px;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  background-color: ${(props: Props) => props.theme.palette.neutral._10};
  border: 2px solid ${(props: Props) => props.theme.palette.neutral._20};
  &:hover {
    background-color: ${(props: Props) => props.theme.palette.neutral._00};
    border: 2px solid ${(props: Props) => props.theme.palette.neutral._00};
  }
`;

export const MaterialContainer = styled.div<Props>`
  display: flex;
  flex-direction: column;
  margin-right: 22px;
  cursor: pointer;
`;

export const StyledVideoIcon = styled(VideoIcon)<Props>`
  color: ${(props: Props) => props.theme.palette.neutral._20} !important;
`;
